import React, {ButtonHTMLAttributes} from "react";
import './AppButton.css'

type AppButtonProps = React.DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
}

const AppButton: React.FC<AppButtonProps> = (props: AppButtonProps) => {
  return (
    <button className={"app-button button-text w-full"} {...props}/>
  );
}

export default AppButton;